import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonDataService } from '../../common-data.service';

@Component({
  selector: 'app-roster-team-card',
  templateUrl: './roster-team-card.component.html',
  styleUrls: ['./roster-team-card.component.scss']
})
export class RosterTeamCardComponent {

  @Input() team: any;
  @Input() teamIndex: number;
  @Input() allTeamIdsTtl: Array<any> = [];
  @Input() defaultShowingMembers: number = 5;
  @Input() isDemoRoster: boolean = false;
  @Input() teamMemberCurrentPg: number = 1;
  @Input() teamsPerPage: number = 20;
  @Input() teamLoading: boolean = false;
  @Input() fullView: boolean = false;
  @Input() slectedIndividualTeamArr: any[] = [];

  @Output() selectedGroupProfileTeams = new EventEmitter<any>();
  @Output() participantView = new EventEmitter<{ from: string; team: any; member?: any }>();
  @Output() openCloseTeamPopup = new EventEmitter<{ open: boolean; teamId: string; teamName: string }>();
  @Output() deleteTeam = new EventEmitter<{ team: any; index: number }>();
  @Output() accordToggle = new EventEmitter<{ className: string; event: MouseEvent }>();
  @Output() removeTeamMember = new EventEmitter<{ member: any; team: any }>();
  @Output() additionalTeamPopup = new EventEmitter<any>();
  @Output() mkTeamLead = new EventEmitter<{ member: any; roleId: number; team: any }>();
  @Output() loadMore = new EventEmitter<{ teamId: string; roaster?: number; allMembers?: boolean }>();
  @Output() memberGoToProfile = new EventEmitter<any>();

  constructor(public CommonDataService: CommonDataService) {}

  secretEmail(usrEmail: string, length = 8): string {
    return usrEmail?.substring(0, length) + '...';
  }

  isTeamSelected(): boolean {
    return this.slectedIndividualTeamArr.some(item => item.id === this.team?.id);
  }

  onSelectedGroupProfileTeams(): void {
    this.selectedGroupProfileTeams.emit(this.team);
  }

  onParticipantViewTeam(): void {
    this.participantView.emit({ from: 'team', team: this.team });
  }

  onParticipantViewMember(member: any): void {
    this.participantView.emit({ from: 'member', team: this.team, member });
  }

  onRenameTeam(): void {
    this.openCloseTeamPopup.emit({ open: true, teamId: this.team?.id, teamName: this.team?.name });
  }

  onDeleteTeam(): void {
    this.deleteTeam.emit({ team: this.team, index: this.teamIndex });
  }

  onAccordToggle(event: MouseEvent): void {
    this.accordToggle.emit({ className: 'orgs_team__members_body--' + this.teamIndex, event });
  }

  onRemoveTeamMember(member: any): void {
    this.removeTeamMember.emit({ member, team: this.team });
  }

  onAdditionalTeamPopup(member: any): void {
    this.additionalTeamPopup.emit(member);
  }

  onMkTeamLead(member: any, roleId: number): void {
    this.mkTeamLead.emit({ member, roleId, team: this.team });
  }

  onLoadMore(): void {
    const i = this.teamIndex;
    const showAll = !(this.team?.memberships_count > this.allTeamIdsTtl[i]?.['showMember'] &&
      this.team?.memberships_count > this.defaultShowingMembers);
    this.loadMore.emit({ teamId: this.team.id, roaster: 0, allMembers: showAll });
  }
}
